import React from 'react'

import { ZariContext } from '_zari/context'
import { Table } from '_zari/core'

import * as Cells from './cells'

import * as AsientoContableService from 'services/asientosContables.service'

const VentasTable = ({ tablaRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaVentas, setListaVentas] = React.useState([])

  const reload = React.useCallback(() => {
    __zariContext.loader.open('Obteniendo ventas con detracción.')

    AsientoContableService.obtenerVentasDetraccion({ listarTodo: true })
      .then(({ data }) => {
        if (data) {
          setListaVentas(data)
          if (data.length === 0) {
            __zariContext.toast('info', 'No se han encontrado registros.')
          } else {
            __zariContext.toast('info', 'Lista actualizada.')
          }
        } else {
          setListaVentas([])
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  React.useEffect(() => {
    reload()
    tablaRef.current.reload = reload
  }, [reload, tablaRef])

  return (
    <Table
      containerId='lista-ventas-detraccion'
      filas={listaVentas}
      headRows={[
        {
          label: 'FECHA'
        },
        {
          label: 'TIPO - SERIE - NUMERO'
        },
        {
          label: 'RUC'
        },
        {
          label: 'RAZON SOCIAL'
        },
        {
          label: 'TOTAL'
        },
        {
          label: 'PAGADO'
        },
        {
          label: 'SALDO'
        },
        {
          label: ''
        }
      ]}
      maxRowsShown={10}
      rowTemplate={(row, key) => (
        <Table.Row key={key}>
          <Table.Cell>{row.fechaEmision ?? '--'}</Table.Cell>
          <Table.Cell>{`${row.tipoDocumento} - ${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
          <Table.Cell>{row.rucSocio ?? '--'}</Table.Cell>
          <Table.Cell>{row.razonSocialSocio ?? '--'}</Table.Cell>
          <Table.Cell>{row.importeTotal ?? '--'}</Table.Cell>
          <Table.Cell>{row.montoCobranza ?? '--'}</Table.Cell>
          <Table.Cell>{row.saldo ?? '0.00'}</Table.Cell>
          <Cells.CheckboxCell row={row} />
        </Table.Row>
      )}
    />
  )
}

export default React.memo(VentasTable)
